
    import './styles.scoped.css';
    export default {
  "progress": "awsui_progress_11huc_52gdr_185",
  "result-state": "awsui_result-state_11huc_52gdr_199",
  "awsui-motion-fade-in": "awsui_awsui-motion-fade-in_11huc_52gdr_1",
  "root": "awsui_root_11huc_52gdr_221",
  "with-result-button": "awsui_with-result-button_11huc_52gdr_232",
  "result-text": "awsui_result-text_11huc_52gdr_236",
  "result-container-error": "awsui_result-container-error_11huc_52gdr_240",
  "result-container-success": "awsui_result-container-success_11huc_52gdr_240",
  "result-button": "awsui_result-button_11huc_52gdr_244",
  "word-wrap": "awsui_word-wrap_11huc_52gdr_249",
  "label-flash": "awsui_label-flash_11huc_52gdr_255",
  "label-key-value": "awsui_label-key-value_11huc_52gdr_259",
  "flash": "awsui_flash_11huc_52gdr_265",
  "progress-container": "awsui_progress-container_11huc_52gdr_269",
  "percentage-container": "awsui_percentage-container_11huc_52gdr_276",
  "percentage": "awsui_percentage_11huc_52gdr_276",
  "complete": "awsui_complete_11huc_52gdr_311",
  "progress-in-flash": "awsui_progress-in-flash_11huc_52gdr_326"
};
  